import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

export type WindowSize = 'mobile' | 'desktop';

export const MOBILE_BREAKPOINT = '(max-width: 1020px)';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  public windowSize: WindowSize = 'desktop';

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([MOBILE_BREAKPOINT])
      .subscribe((result: BreakpointState) => {
        this.windowSize = result.matches ? 'mobile' : 'desktop';
      });
  }

  get isMobile(): boolean {
    return this.windowSize === 'mobile';
  }

  get isDesktop(): boolean {
    return this.windowSize === 'desktop';
  }
}
